import React, { Component } from "react";
import ReporteConversionVentas from "./ReporteConversionVentas";

/**
 * Reporte "Pedido Vs Ventas".
 *
 * Por proyecto: cuanto se pidio contra cuanto acabo siendo venta.
 *
 * A diferencia de la cotizacion, `Pedido.insumos[].vendido` solo lo mueve el paso a Venta, asi
 * que el monto convertido sale exacto sin necesidad de acotarlo contra las ventas.
 *
 * Toda la pantalla vive en `ReporteConversionVentas`, que comparte con "Cotizacion Vs Ventas".
 */
const CONFIG = {
  titulo: "Pedido Vs Ventas",
  endpoint: "reportePedidoVsVentas",
  nombreFormulario: "reportePedidoVsVentas",
  nombreArchivo: "Pedido_Vs_Ventas",
  singular: "Pedido",
  plural: "Pedidos",
  etiquetaMonto: "Pedido",
  etiquetaCantidad: "Cant. pedida",
  rutaVer: "/panel/verPedido",
  campoEstado: "estadoPedidos",
  etiquetaFiltroEstado: "Estado de los Pedidos",
  // Mismos valores que consume `reportePedidos` en el backend.
  opcionesEstado: [
    { value: 5, label: "Activos" },
    { value: 1, label: "Vigentes" },
    { value: 2, label: "Pendientes" },
    { value: 3, label: "Terminados" },
    { value: 0, label: "Cancelados" },
  ],
};

class ReportePedidoVsVentas extends Component {
  render() {
    return <ReporteConversionVentas {...this.props} config={CONFIG} />;
  }
}

export default ReportePedidoVsVentas;
